import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

const AutoComplete = ({
  groupedSuggestions,
  setFilter,
  setsearchValue,
  isLoadingSuggestions,
}) => {
  const {t} = useTranslation();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [pendingResultSearch, setPendingResultSearch] = useState(null);

  useEffect(() => {
    const normalizedInput = userInput.trim();
    const timer = setTimeout(() => {
      setsearchValue(normalizedInput.length >= 2 ? normalizedInput : "");
    }, 300);

    return () => clearTimeout(timer);
  }, [setsearchValue, userInput]);

  useEffect(() => {
    if (pendingResultSearch === null) return undefined;

    const timer = setTimeout(() => {
      const normalizedSearch = pendingResultSearch.trim();
      setFilter((prev) => ({
        ...prev,
        search: normalizedSearch.length >= 2 ? normalizedSearch : "",
        filter: {
          ...prev.filter,
          categoryIds: [],
          subCategoryIds: [],
          sectorIds: [],
        },
      }));
    }, 350);

    return () => clearTimeout(timer);
  }, [pendingResultSearch, setFilter]);

  const filteredGroups = useMemo(() => {
    const searchTerms = userInput.toLowerCase().split(/\s+/).filter(Boolean);
    if (searchTerms.length === 0 || userInput.trim().length < 2) return [];

    return groupedSuggestions
      .filter((group) => group?.items?.length > 0)
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => {
          if (group.group === "prestataires") {
            const fullName = `${item?.User?.firstName || ""} ${
              item?.User?.lastName || ""
            }`.toLowerCase();
            return searchTerms.every((term) => fullName.includes(term));
          }

          const title = item?.title?.toLowerCase() || "";
          return searchTerms.every((term) => title.includes(term));
        }),
      }))
      .filter((group) => group.items.length > 0);
  }, [groupedSuggestions, userInput]);

  const onChange = (e) => {
    const input = e.target.value;
    setPendingResultSearch(input);
    if (input.length === 0) {
      setPendingResultSearch(null);
      setFilter((prev) => ({
        ...prev,
        search: "",
        filter: {
          ...prev.filter,
          categoryIds: [],
          subCategoryIds: [],
          sectorIds: [],
        },
      }));
    }
    setUserInput(input);
    if (input.length >= 2) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  const onClick = (ele, group) => {
    const displayValue =
      group === "prestataires"
        ? `${ele?.User?.firstName || ""} ${ele?.User?.lastName || ""}`.trim()
        : ele?.title || "";
    setUserInput(displayValue);
    setPendingResultSearch(null);
    setsearchValue(displayValue);
    if (group === "secteurs") {
      setFilter((prev) => ({
        ...prev,
        search: "",
        filter: {
          ...prev.filter,
          categoryIds: [],
          subCategoryIds: [],
          sectorIds: [parseInt(ele.id)],
        },
      }));
    } else if (group === "categories") {
      setFilter((prev) => ({
        ...prev,
        search: "",
        filter: {
          ...prev.filter,
          subCategoryIds: [],
          sectorIds: [],
          categoryIds: [parseInt(ele.id)],
        },
      }));
    } else if (group === "subCategories") {
      setFilter((prev) => ({
        ...prev,
        search: "",
        filter: {
          ...prev.filter,
          categoryIds: [],
          sectorIds: [],
          subCategoryIds: [parseInt(ele.id)],
        },
      }));
    } else if (group === "prestataires") {
      setFilter((prevFilter) => ({
        ...prevFilter,
        filter: {
          ...prevFilter.filter,
          categoryIds: [],
          subCategoryIds: [],
          sectorIds: [],
        },
        search: displayValue,
      }));
    }
    setShowSuggestions(false);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setPendingResultSearch(null);
      setFilter((prevFilter) => ({
        ...prevFilter,
        search: userInput.trim(),
        filter: {
          ...prevFilter.filter,
          categoryIds: [],
          subCategoryIds: [],
          sectorIds: [],
        },
      }));
      setShowSuggestions(false);
    }
  };

  const SuggestionsList = () => (
    <div className="suggestions-container    z-10 !pb-3 bg-white w-full rounded-b-[28px]">
      {isLoadingSuggestions && (
        <div className="text-[#7E7E7E] px-5 py-2 text-xs">
          {t("loadingProviders")}
        </div>
      )}
      {filteredGroups.some(
        (group) => group.group !== "prestataires" && group.items?.length,
      ) && (
        <div className="text-[#19295C] ml-4 mb-2 text-sm font-semibold ">
          {t("services")}
        </div>
      )}
      {filteredGroups.map((group, groupIndex) => (
        <div key={group.group} className="suggestion-group   ">
          {group.group === "prestataires" && group?.items?.length > 0 && (
            <div className="text-[#19295C] ml-4  mb-2 text-sm font-semibold">
              {t("navProviders")}
            </div>
          )}
          <ul>
            {group.items.map((item, itemIndex) => {
              // const flatIndex =
              //   filteredGroups.slice(0, groupIndex).flatMap((g) => g.items)
              //     .length + itemIndex;

              return (
                <li
                  key={`${group.group}-${item.id}`}
                  // className={
                  //   flatIndex === activeSuggestionIndex ? "active" : ""
                  // }
                  className="cursor-pointer hover:bg-[#D5E3F3] text-sm pl-5 text-[#5a5a5a] leading-6"
                  // data-value={item}
                  onClick={() => onClick(item, group.group)}
                >
                  {item?.title ??
                    item?.User?.firstName + " " + item?.User?.lastName}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
      {!isLoadingSuggestions && filteredGroups.length === 0 && (
        <div className="text-[#7E7E7E] px-5 py-2 text-xs">
          {t("noProviderSuggestions")}
        </div>
      )}
    </div>
  );

  return (
    <div
      className={`flex-grow min-h-[52px] rounded-[28px] ${
        showSuggestions && userInput ? "bg-white" : "bg-none"
      }`}
    >
      <div className="flex w-full h-[52px] min-h-[52px] text-[#7E7E7E] items-center gap-2 bg-white rounded-[28px] p-3 text-sm ">
        <i className="!ml-2 fi fi-rr-search flex justify-center items-center"></i>
        <input
          type="text"
          className="flex-grow w-[90%] text-[#19295C] "
          placeholder={t("providerSearchPlaceholder")}
          value={userInput}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        {isLoadingSuggestions && (
          <i className="fi fi-rr-spinner animate-spin flex items-center"></i>
        )}
        {!!userInput && (
          <i
            className="fi fi-rr-cross-small flex items-center cursor-pointer"
            onClick={() => {
              setUserInput("");
              setPendingResultSearch(null);
              setsearchValue("");
              setFilter((prev) => ({
                ...prev,
                filter: {
                  ...prev.filter,
                  categoryIds: [],
                  subCategoryIds: [],
                  sectorIds: [],
                },
                search: "",
              }));
            }}
          ></i>
        )}
      </div>
      {showSuggestions && userInput && <SuggestionsList />}
    </div>
  );
};

export default AutoComplete;
